import React, { Fragment, useState, useContext, useEffect } from "react";
import { AppContext } from "../Utils/AppContext";
import Page from "../Layout/Page";
import CompanyTable from "../Tables/CompanyTable";
import CompanyForm from "../Forms/CompanyForm";

const Companies = () => {
  const [showCompanyForm, setShowCompanyForm] = useState(false);

  return (
    <Page title="Companies">
      <CompanyTable />

      {showCompanyForm && (
        <Fragment>
          <br />
          <CompanyForm
            formComplete={() => {
              setShowCompanyForm(false);
            }}
          />

          <button
            type="button"
            onClick={() => {
              setShowCompanyForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}

      {!showCompanyForm && (
        <Fragment>
          <button
            type="button"
            onClick={() => {
              setShowCompanyForm(true);
            }}
          >
            Add Company
          </button>
        </Fragment>
      )}
    </Page>
  );
};

export default Companies;
